import React, { useMemo } from "react";

import { Sandbox } from "@dangreaves/react-sandbox";

export interface ReviewsSentimentWidgetProps {
  /**
   * Handle for the product.
   */
  productHandle: string;
  /**
   * Array of variant SKUs associated with product.
   */
  variantSkus: string[];
}

export function ReviewsSentimentWidget({
  productHandle,
  variantSkus,
}: ReviewsSentimentWidgetProps) {
  // REVIEWS.io takes a string delimited by a semicolon.
  const dataSkuAttribute = useMemo(
    () => [productHandle, ...variantSkus].join(";"),
    [productHandle, variantSkus],
  );

  // Resolve path to sandbox stylesheet.
  const sandboxStylesheet =
    "production" === process.env.NODE_ENV
      ? "/assets/sandbox.css"
      : "/sandbox.css";

  // Include the global style sheet for fonts.
  const headContent = [
    `<link href="${sandboxStylesheet}" rel="stylesheet" />`,
  ].join("\n");

  // Render body content.
  const bodyContent = [
    // REVIEWS.io injects content into this div.
    `<div lang="en" data-store-name="bared." widget-id="7caFQtBVl0sCZwod" data-sku="${dataSkuAttribute}" class="reviews-io-sentiment-widget"></div>`,
    // REVIEWS.io script.
    `<script src="//widget.reviews.io/modern-widgets/sentiment.js"></script>`,
    // Show iframe only when REVIEWS.io has injected some content.
    `<script>
      (() => {
        function checkReady() {
          const injectedContent = document.querySelector(".SentimentWidget");
          if (!!injectedContent) showSandbox();
          else hideSandbox();
        }
        const observer = new MutationObserver(checkReady);
        observer.observe(document.body, { childList: true, subtree: true });
      })();
    </script>`,
  ].join("\n");

  return (
    <Sandbox
      className="mr-midi"
      key={dataSkuAttribute}
      headContent={headContent}
      initialHidden
    >
      {bodyContent}
    </Sandbox>
  );
}
